export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export interface Article {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  date: string;
  category: string;
  categorySlug: string;
  image: string;
  author: string;
  tags: string[];
}

export const categories: Category[] = [
  { slug: "all", name: "全部作品", description: "浏览水野朝阳的全部作品合集", icon: "ri-stack-line" },
  { slug: "drama", name: "剧情系列", description: "精心编排的剧情类作品精选", icon: "ri-movie-2-line" },
  { slug: "youth", name: "青春系列", description: "青春洋溢的校园与恋爱主题作品", icon: "ri-heart-pulse-line" },
  { slug: "urban", name: "都市系列", description: "展现都市成熟魅力的作品集", icon: "ri-building-2-line" },
  { slug: "news", name: "活动报道", description: "水野朝阳的公开活动与新闻资讯", icon: "ri-newspaper-line" },
  { slug: "awards", name: "荣誉奖项", description: "获奖记录与业界认可", icon: "ri-trophy-line" },
  { slug: "fan", name: "粉丝活动", description: "粉丝见面会与互动活动报道", icon: "ri-user-heart-line" },
  { slug: "personal", name: "个人动态", description: "水野朝阳的生活分享与日常记录", icon: "ri-user-star-line" },
];

export const articles: Article[] = [
  {
    id: 1,
    title: "阳光下的邂逅 — 水野朝阳2024开年力作深度解析",
    excerpt: "作为2024年的开年大作，水野朝阳在这部作品中展现出了前所未有的表演深度与情感层次。从剧本创作到角色塑造，每一个细节都凝聚了她的心血。",
    content: `<p>作为2024年的开年大作，水野朝阳在这部作品中展现出了前所未有的表演深度与情感层次。从剧本创作到角色塑造，每一个细节都凝聚了她的心血与专注。</p>
    <p>本作品以海滨小镇为舞台，讲述了一段跨越时空的动人故事。水野朝阳在片中饰演一位内心复杂的女性角色，通过细腻的表情管理与肢体语言，将角色的情感起伏刻画得入木三分。导演在接受采访时表示："水野的表演让剧本中的角色真正活了起来，她赋予了角色灵魂。"</p>
    <p>拍摄历时三个月，辗转东京、镰仓、冲绳三地取景。水野朝阳为了更好地理解角色，提前一个月就开始进行角色研究，甚至专门学习了冲绳方言，只为在片中呈现最真实的表演。她对于每一个镜头的投入与执着，赢得了全剧组的一致赞誉。</p>
    <p>作品上映后，迅速在业界引发热议。多位资深评论人给予高度评价，认为这是水野朝阳演艺生涯中的一个重要里程碑。影迷们也在社交媒体上纷纷表达了对这部作品的喜爱，相关话题一度登上热门榜单。</p>
    <p>水野朝阳本人在接受本网站独家采访时说道："每一部作品都是我与观众的一次对话，我希望能通过表演传达出最真实的情感。这部作品对我而言意义非凡，因为它让我重新审视了自己的演艺之路。"</p>
    <p>展望未来，水野朝阳表示将继续挑战更多不同类型的角色，不断突破自我，为观众带来更多惊喜。她的敬业精神与对演艺事业的热爱，正是她能够持续保持高水准表现的关键所在。</p>`,
    date: "2024-01-15",
    category: "剧情系列",
    categorySlug: "drama",
    image: "https://readdy.ai/api/search-image?query=Japanese%20woman%20standing%20on%20beach%20at%20sunset%2C%20wind%20blowing%20hair%2C%20warm%20golden%20light%2C%20cinematic%20wide%20shot%2C%20emotional%20atmosphere%2C%20professional%20photography%2C%20ocean%20waves&width=800&height=500&seq=mizuno-article-01&orientation=landscape",
    author: "水野朝阳官方粉丝站",
    tags: ["2024新作", "剧情系列", "深度解析", "推荐"],
  },
  {
    id: 2,
    title: "夜的第七章 — 都市夜色中的深情演绎",
    excerpt: "「夜的第七章」以东京夜晚的繁华街头为背景，呈现了一段都市成年人的情感故事。水野朝阳以她标志性的细腻表演，诠释了一个既坚强又脆弱的都市女性形象。",
    content: `<p>「夜的第七章」以东京夜晚的繁华街头为背景，呈现了一段都市成年人的情感故事。水野朝阳以她标志性的细腻表演，诠释了一个既坚强又脆弱的都市女性形象，引发了无数观众的共鸣。</p>
    <p>故事围绕一位在东京打拼的职场女性展开。白天她是雷厉风行的精英，夜晚却独自面对内心的孤独与迷茫。水野朝阳精准地捕捉到了角色在两种截然不同状态之间的转换，让观众看到了都市生活中不为人知的另一面。</p>
    <p>"这个角色让我想起了自己刚来东京时的模样，"水野朝阳分享道，"那种既充满希望又感到不安的矛盾心情，我非常熟悉。所以在演绎的时候，我把自己的真实感受也融入了角色之中。"</p>
    <p>影片的画面美学同样令人印象深刻。导演运用了大量霓虹灯光与暗影的对比，营造出迷离而富有诗意的视觉效果。水野朝阳与镜头的互动自然流畅，每一个特写都充满了故事感，让人不禁沉浸其中。</p>
    <p>这部作品自发布以来，获得了众多业内人士的推荐，被评价为"近年都市题材作品中的一股清流"。它不仅展示了水野朝阳的演技实力，更体现了她在选择剧本方面的独到眼光。</p>`,
    date: "2024-03-20",
    category: "剧情系列",
    categorySlug: "drama",
    image: "https://readdy.ai/api/search-image?query=Elegant%20Japanese%20woman%20in%20Tokyo%20night%20street%2C%20neon%20lights%20reflecting%2C%20rainy%20pavement%2C%20cinematic%20mood%2C%20professional%20photography%2C%20warm%20amber%20and%20cool%20blue%20contrast%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=mizuno-article-02&orientation=landscape",
    author: "水野朝阳官方粉丝站",
    tags: ["都市系列", "剧情系列", "东京", "情感"],
  },
  {
    id: 3,
    title: "夏日记忆 — 青春物语的完美呈现",
    excerpt: "「夏日记忆」带领观众回到了那个充满蝉鸣与阳光的夏天，水野朝阳化身青春少女，用清新自然的表演征服了所有观众的心。",
    content: `<p>「夏日记忆」带领观众回到了那个充满蝉鸣与阳光的夏天。水野朝阳化身青春少女，用清新自然的表演征服了所有观众的心，这部作品也成为当年最受好评的青春题材作品之一。</p>
    <p>影片以一所海边高中为舞台，讲述了几个少年少女在最后一个暑假里发生的成长故事。水野朝阳饰演的角色是一个外表开朗但内心细腻的女孩，她对友情与初恋的懵懂体验，勾起了许多观众对青春岁月的美好回忆。</p>
    <p>为配合角色设定，水野朝阳在拍摄期间刻意保持素颜状态，以最真实的面貌呈现在镜头前。这种对真实的追求，让她的表演显得尤为自然动人。拍摄现场的许多工作人员都表示，看到她的表演时常常会忘记这是在工作，仿佛真的在见证一段青春故事的发生。</p>
    <p>影片的配乐也是一大亮点，由知名音乐制作人操刀，将夏日的清新感与青春的悸动完美融合。水野朝阳表示，她在拍摄前反复聆听这些音乐，用来帮助自己进入角色的情感世界。</p>
    <p>「夏日记忆」不仅是水野朝阳拓宽戏路的一次成功尝试，更证明了她在不同类型的作品中都能交出令人满意的答卷。作品的评分达到了4.9分，是水野朝阳所有作品中评分最高的之一。</p>`,
    date: "2023-07-10",
    category: "青春系列",
    categorySlug: "youth",
    image: "https://readdy.ai/api/search-image?query=Japanese%20woman%20in%20summer%20school%20uniform%20at%20seaside%2C%20bright%20sunlight%2C%20blue%20sky%2C%20gentle%20smile%2C%20youthful%20atmosphere%2C%20professional%20photography%2C%20fresh%20and%20clean%20aesthetic&width=800&height=500&seq=mizuno-article-03&orientation=landscape",
    author: "水野朝阳官方粉丝站",
    tags: ["青春系列", "夏日", "校园", "高评分"],
  },
  {
    id: 4,
    title: "东京恋语 — 都会爱情的多重奏",
    excerpt: "以东京这座不夜城为舞台，「东京恋语」展现了现代都市中复杂而真实的爱情样貌。水野朝阳一人分饰多角，挑战自我演艺的边界。",
    content: `<p>以东京这座不夜城为舞台，「东京恋语」展现了现代都市中复杂而真实的爱情样貌。水野朝阳在片中面临了前所未有的演技挑战，以精湛的表演赢得了广泛赞誉。</p>
    <p>影片采用多线叙事结构，通过几个看似独立却又相互关联的爱情故事，勾勒出当代都市人的情感图谱。水野朝阳的角色是串联所有故事的核心人物，她的每一次出场都推动着剧情的发展，让整个叙事结构显得更加完整和有机。</p>
    <p>"这是我演过最有挑战性的角色之一，"水野朝阳坦言，"角色的情感弧线非常复杂，需要我在不同的情绪之间快速切换。有时候一天之内要拍摄好几场完全不同氛围的戏，对体力和精神力都是极大的考验。"</p>
    <p>为了呈现最完美的效果，水野朝阳在拍摄期间每天只睡四到五个小时，其余时间全部用于研读剧本和练习台词。她的敬业态度感染了整个剧组，也最终成就了这部品质出众的作品。</p>
    <p>「东京恋语」上映后，迅速成为社交平台上的热门话题。许多观众在评论中表示，被水野朝阳的表演深深打动，认为她将都市女性的喜怒哀乐诠释得淋漓尽致。这部作品也为她赢得了当年的"最佳女演员"提名。</p>`,
    date: "2023-11-05",
    category: "都市系列",
    categorySlug: "urban",
    image: "https://readdy.ai/api/search-image?query=Stylish%20Japanese%20woman%20in%20Tokyo%20cityscape%20at%20twilight%2C%20modern%20high-rise%20buildings%2C%20warm%20city%20lights%2C%20professional%20portrait%20photography%2C%20sophisticated%20urban%20vibe%2C%20cinematic%20wide%20shot&width=800&height=500&seq=mizuno-article-04&orientation=landscape",
    author: "水野朝阳官方粉丝站",
    tags: ["都市系列", "东京", "情感", "多线叙事"],
  },
  {
    id: 5,
    title: "水野朝阳2025年最新作品发布会圆满举行",
    excerpt: "水野朝阳出席了在东京举办的2025年度新作发布会，现场分享了创作背后的故事与心路历程，引发粉丝热烈反响。",
    content: `<p>2025年3月15日，水野朝阳出席了在东京举办的2025年度新作发布会。在发布会现场，她与媒体和粉丝代表分享了新作品的创作历程、拍摄幕后故事以及个人心路感悟，引发热烈反响。</p>
    <p>发布会上，水野朝阳以一身优雅的白色套装亮相，状态极佳。她首先感谢了所有支持者多年来的陪伴与鼓励，表示正是粉丝们的支持给了她不断前进的动力。随后，她详细介绍了2025年的作品规划，包括三个不同题材的全新企划。</p>
    <p>"今年的三部作品分别探讨了不同的主题，每一部都代表了我对演艺事业的不同理解和追求，"水野朝阳说道，"我希望通过这些作品，让观众看到一个更加立体、更加真实的我。"</p>
    <p>现场还设置了粉丝互动环节，水野朝阳亲切地回答了多位粉丝的提问。当被问及如何保持对工作的热情时，她真诚地回答道："热爱是最好的老师。当你真正热爱一件事情的时候，每一天都是崭新的开始。"</p>
    <p>发布会最后，水野朝阳向所有支持者送上了真挚的祝福，并表示期待在新的一年里与大家共同创造更多美好的回忆。</p>`,
    date: "2025-03-15",
    category: "活动报道",
    categorySlug: "news",
    image: "https://readdy.ai/api/search-image?query=Press%20conference%20event%20with%20elegant%20Japanese%20woman%20speaking%20on%20stage%2C%20professional%20lighting%2C%20microphone%2C%20warm%20atmosphere%2C%20event%20photography%2C%20sophisticated%20venue%2C%20audience&width=800&height=500&seq=mizuno-article-05&orientation=landscape",
    author: "水野朝阳官方粉丝站",
    tags: ["2025", "发布会", "活动", "新作"],
  },
  {
    id: 6,
    title: "粉丝见面会精彩回顾：感恩一路相伴",
    excerpt: "上周末于大阪举办的粉丝见面会圆满落幕，水野朝阳与数百名粉丝亲密互动，现场气氛温馨感人。",
    content: `<p>上周末，水野朝阳于大阪举办了盛大的粉丝见面会，数百名来自全国各地的粉丝齐聚一堂，与水野朝阳共同度过了一个温馨难忘的午后时光。</p>
    <p>活动于下午两点正式开始，水野朝阳以一身简约优雅的装扮登场，瞬间点燃了全场的热情。她首先向所有到场的粉丝表达了诚挚的感谢，"没有你们的支持，就不会有今天的我。每一次见面会，都是我最期待的时刻，因为可以真正和你们面对面交流。"</p>
    <p>见面会设置了多个互动环节，包括问答环节、游戏环节以及握手会。在问答环节中，粉丝们提出了各种有趣的问题，从工作日常到个人喜好，水野朝阳都一一耐心作答，现场笑声不断。游戏环节更是将气氛推向了高潮，水野朝阳与粉丝们组队竞技，展现出亲和幽默的一面。</p>
    <p>最令人动容的是握手会环节。每一位粉丝都有机会与水野朝阳进行简短的一对一交流。许多粉丝在见到偶像的瞬间激动落泪，而水野朝阳则以温暖的微笑和鼓励的话语回应每一位支持者。</p>
    <p>活动持续了近四个小时，但无论是水野朝阳还是粉丝们，都表示时间过得太快。"每次见面会结束后，我都会感到满满的幸福和能量，"水野朝阳在活动后的采访中说道，"粉丝们的爱与支持，是我最大的财富。"</p>`,
    date: "2025-02-28",
    category: "粉丝活动",
    categorySlug: "fan",
    image: "https://readdy.ai/api/search-image?query=Fan%20meeting%20event%20Japanese%20celebrity%20waving%20to%20enthusiastic%20crowd%2C%20indoor%20event%20space%2C%20warm%20spotlight%2C%20joyful%20atmosphere%2C%20professional%20event%20photography%2C%20banner%20in%20background&width=800&height=500&seq=mizuno-article-06&orientation=landscape",
    author: "水野朝阳官方粉丝站",
    tags: ["粉丝见面会", "大阪", "活动", "互动"],
  },
  {
    id: 7,
    title: "水野朝阳荣获年度最佳女演员提名",
    excerpt: "业界权威奖项公布年度提名名单，水野朝阳凭借过去一年的出色表现再度获得最佳女演员提名。",
    content: `<p>业界权威奖项机构于近日公布了2025年度各大奖项的提名名单，水野朝阳凭借过去一年在多个作品中的卓越表现，再度获得"年度最佳女演员"提名。这是她职业生涯中第15次获得重要奖项提名，充分体现了业界对她专业能力的高度认可。</p>
    <p>在过去的一年中，水野朝阳出演了多部口碑与市场双丰收的作品，涵盖了剧情、青春、都市等多个类型。每一部作品都展现了她不断精进的演技和对角色的深刻理解。评审委员会在提名评语中写道："水野朝阳以她对表演的热爱与执着，持续为观众带来高质量的演出，是业界当之无愧的中坚力量。"</p>
    <p>得知提名消息后，水野朝阳第一时间通过社交媒体向粉丝表达了感谢："这个提名属于所有支持我的人。每一次提名都是对我工作的肯定，但更重要的是，它提醒我要继续努力，不断超越自己。"</p>
    <p>2025年的年度颁奖典礼将于下月在东京举行。届时，水野朝阳将与其他入围者一同角逐这一殊荣。无论最终结果如何，这次提名本身已经是对她一年来辛勤付出的最好回馈。</p>
    <p>水野朝阳在演艺道路上已经走过了十三个年头。从最初的新人到如今的业界翘楚，她用一部部作品证明了自己的实力，也用真诚的态度赢得了广泛的尊重与喜爱。</p>`,
    date: "2025-01-20",
    category: "荣誉奖项",
    categorySlug: "awards",
    image: "https://readdy.ai/api/search-image?query=Award%20trophy%20on%20elegant%20display%20pedestal%2C%20warm%20spotlight%2C%20red%20carpet%20background%2C%20prestigious%20atmosphere%2C%20golden%20and%20amber%20tones%2C%20professional%20photography%2C%20celebration%20mood&width=800&height=500&seq=mizuno-article-07&orientation=landscape",
    author: "水野朝阳官方粉丝站",
    tags: ["奖项", "提名", "荣誉", "2025"],
  },
  {
    id: 8,
    title: "新年问候：水野朝阳的2025年展望",
    excerpt: "在新年伊始，水野朝阳通过官方粉丝站向所有支持者致以诚挚问候，并分享了新一年的工作计划与个人目标。",
    content: `<p>2025年的第一天，水野朝阳通过官方粉丝站向全球支持者发来了新年问候。在这封温暖而真诚的新年致辞中，她回顾了过去一年的点点滴滴，并分享了新一年的美好展望。</p>
    <p>"新年快乐！感谢大家在2024年的陪伴与支持，"水野朝阳在致辞中写道，"过去的一年里，我完成了多部令自己满意的作品，也通过见面会和线上活动与许多粉丝有了更深入的交流。这些美好的瞬间，都将成为我永远珍藏的回忆。"</p>
    <p>谈及2025年的计划，水野朝阳表示将重点推进三个方向：首先是继续深耕演艺事业，挑战更多有深度的角色；其次是加强个人品牌的打造，推出更多与粉丝互动的创新形式；最后是在个人成长方面，她计划学习一门新的语言并尝试更多元的兴趣爱好。</p>
    <p>"新的一年意味着新的可能。我希望自己能够保持初心，以更加饱满的热情面对每一天的工作和生活，"水野朝阳写道，"更重要的是，我希望能与所有支持我的人一起，共同书写属于我们的精彩篇章。"</p>
    <p>水野朝阳还特别提到，2025年将是她出道的第13个年头。"13年，说长不长，说短不短。但每一天对于我来说都是珍贵的。感谢这份职业让我遇见了你们，也遇见了更好的自己。"</p>
    <p>这篇新年致辞在粉丝社群中引起了强烈共鸣，许多粉丝纷纷留言回应，表达了对水野朝阳的祝福与期待。</p>`,
    date: "2025-01-01",
    category: "个人动态",
    categorySlug: "personal",
    image: "https://readdy.ai/api/search-image?query=Japanese%20woman%20in%20beautiful%20kimono%20at%20traditional%20Japanese%20temple%20during%20New%20Year%2C%20warm%20sunlight%2C%20peaceful%20atmosphere%2C%20first%20sunrise%2C%20professional%20photography%2C%20elegant%20composition&width=800&height=500&seq=mizuno-article-08&orientation=landscape",
    author: "水野朝阳官方粉丝站",
    tags: ["新年", "2025", "展望", "个人动态"],
  },
];

export function getArticlesByCategory(slug: string): Article[] {
  if (slug === "all") return articles;
  return articles.filter((a) => a.categorySlug === slug);
}

export function getArticleById(id: number): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug);
}